import React, { useEffect } from "react";
import { Modal, Form, Button, Col, Row, message, Upload } from "antd";
import { API_METHODS } from "../../../constants";
import useApi from "../../../hooks/useApi";
import { UploadOutlined } from "@ant-design/icons";

function UploadCategory(props) {
  const { visible, close } = props;
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [response, request] = useApi(
    "/config/category/upload",
    null,
    API_METHODS.POST,
    true // for form data
  );

  useEffect(() => {
    if (response.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "File uploaded successfully.",
      });
    }
  }, [response]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        if (values["file"] !== undefined) {
          formData.append(
            "file",
            values["file"].file.originFileObj,
            values["file"].file.name
          );
        }

        request(formData);
      })
      .catch((e) => {});
  };

  const handleCancel = () => {
    close();
  };

  const excelMimeTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    "application/vnd.ms-excel.sheet.macroEnabled.12",
    "application/vnd.ms-excel.template.macroEnabled.12",
    "application/vnd.ms-excel.addin.macroEnabled.12",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
    "application/vnd.oasis.opendocument.spreadsheet", // .ods
    "text/csv", // CSV files are often handled by Excel
    "text/tab-separated-values", //TSV files are also often handled by Excel
  ];

  function isExcelFile(file) {
    if (!file || !file.type) {
      return false; // Handle cases where file or file.type is undefined
    }
    return excelMimeTypes.includes(file.type);
  }

  const uploadProps = {
    beforeUpload: (file) => {
      const isExcel = isExcelFile(file);
      if (!isExcel) {
        messageApi.open({
          type: "error",
          content: "Excel Files are supported.",
        });
      }
      return isExcel || Upload.LIST_IGNORE;
    },
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  return (
    <Modal
      title="Upload Category"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      {contextHolder}
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="file"
              label="Upload File"
              rules={[{ required: true, message: "File is required." }]}
            >
              <Upload
                customRequest={dummyRequest}
                {...uploadProps}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default UploadCategory;
